/**
 * Redirect NL/FR cutting-board synonyms to the cutting-board collection.
 * More reliable than remapping search query text.
 */
(function () {
  try {
    var path = (window.location.pathname || '').toLowerCase();
    if (path.indexOf('/search') === -1) return;
    var params = new URLSearchParams(window.location.search);
    var q = (params.get('q') || '').trim().toLowerCase().replace(/\s+/g, ' ');
    if (!q) return;
    var boardAliases = {
      snijplank: 1,
      'snij planken': 1,
      snijplanken: 1,
      snijbord: 1,
      'planche a decouper': 1,
      'planche à découper': 1,
      'cutting surface': 1,
      'cutting board': 1,
      'cutting boards': 1
    };
    if (!boardAliases[q]) return;
    window.location.replace('/collections/titanium-cutting-system');
  } catch (e) {}
})();
